import { useSWRFetch } from './internal/useSWRFetch';
import { getProductInfoDialogTranslations } from '../api';
import { getTranslationsWithFallback } from '../translations';
export var useGetProductInfoDialogTranslations = function useGetProductInfoDialogTranslations(_ref) {
  var currentLanguage = _ref.currentLanguage,
    translationsUrl = _ref.translationsUrl;
  return useSWRFetch({
    fallback: getTranslationsWithFallback(),
    fetcher: async function fetcher() {
      return getProductInfoDialogTranslations({
        currentLanguage: currentLanguage,
        translationsUrl: translationsUrl
      });
    },
    key: [currentLanguage, translationsUrl]
  });
};